import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_CAMPAIGN } from 'src/graphql/campaigns/queries';
import { useParams } from 'react-router';
import OrganizationTasksStatus from '../../superadmin/organization-tasks-status'

const TaskStatus = () => {
  const { campaignId } = useParams();
  const { data: campaign } = useQuery(GET_CAMPAIGN, {
    variables: {
      campaign_id: campaignId,
    },
  });

  return (
    <>
      {campaign && (
        <OrganizationTasksStatus
          inCampaigns={true}
          organization_id={campaign?.row?.campaigns_organization.organization_id}
          campaign_id={campaignId}
        />
      )}
    </>
  );
};

export default TaskStatus;
